import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import CarrierGuardFreightsService from '../services/CarrierGuardFreightsService';

export const CARRIER_GUARD_FREIGHTS_QUERY_KEY = '3rd-party-management-fetch-carrier-guard-freights';

const useCarrierGuardFreights = ({
    filters,
    t,
}) => {
    return useQuery({
        queryKey: [CARRIER_GUARD_FREIGHTS_QUERY_KEY, filters],
        queryFn: async () => {
            const service = CarrierGuardFreightsService.getInstance();

            return await service.list(filters);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        onError: () => {
            toast(t('An error occurred while fetching freights list.'), {
                type: 'error',
            });
        },
    });
};

export default useCarrierGuardFreights;
